import { i18n } from '../index'

export const useValidators = () => {
  const { t } = i18n.global

  const required = (value: any): string | boolean => {
    if (!value || (typeof value === 'string' && !value.trim())) {
      return t('validation.required')
    }
    return true
  }

  const email = (value: string): string | boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(value)) {
      return t('validation.email')
    }
    return true
  }

  const minLength = (min: number) => {
    return (value: string): string | boolean => {
      if (value.length < min) {
        return t('validation.minLength', { count: min })
      }
      return true
    }
  }

  const maxLength = (max: number) => {
    return (value: string): string | boolean => {
      if (value.length > max) {
        return t('validation.maxLength', { count: max })
      }
      return true
    }
  }

  const password = (value: string): string | boolean => {
    const hasUpperCase = /[A-Z]/.test(value)
    const hasLowerCase = /[a-z]/.test(value)
    const hasNumbers = /\d/.test(value)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value)

    if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChar || value.length < 8) {
      return t('validation.password')
    }
    return true
  }

  return {
    required,
    email,
    minLength,
    maxLength,
    password
  }
}